import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";

export default function PressureScorer() {
  return (
    <div className="grid lg:grid-cols-12 gap-10" data-testid="pressure-scorer-page">
      <div className="lg:col-span-5 space-y-6">
        <Link to="/stage/product" className="label-eyebrow" data-testid="ps-back">← The Product</Link>
        <div>
          <div className="label-eyebrow mb-3 mt-2 text-[var(--brand-primary)]">Live product demo</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">The Pressure Scorer.</h1>
          <p className="mt-4 text-neutral-500 leading-relaxed">
            This is the tool your prospects are holding when they get on a call with you. Search a suburb,
            read the vendor pressure score, save it to a watchlist — experience exactly what they experience.
          </p>
        </div>
        <div className="border hairline bg-[color:var(--brand-surface2)] p-5 space-y-3 text-sm">
          <div className="label-eyebrow">Use it for Stage 2</div>
          <p className="leading-relaxed">In the four-screen walkthrough, this is the moment you find one piece of <strong>specific intelligence</strong> relevant to their situation. Practise pulling a suburb insight you could drop naturally into conversation.</p>
          <p className="leading-relaxed text-neutral-500">Everything in this demo runs on sample data — click around freely.</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-neutral-400">
          <Smartphone size={14} /> Interactive demo · best experienced in the phone frame
        </div>
      </div>

      <div className="lg:col-span-7 flex justify-center lg:justify-start">
        <div className="border-[10px] border-[#1A1A1A] rounded-[36px] shadow-2xl overflow-hidden bg-[#1A1A1A]" style={{ width: 400, height: 780, maxWidth: "100%" }}>
          <iframe
            src="/pressure-scorer.html"
            title="Proptix Pressure Scorer demo"
            data-testid="pressure-scorer-iframe"
            className="w-full h-full rounded-[26px] bg-white"
            style={{ border: "none" }}
          />
        </div>
      </div>
    </div>
  );
}
